module.exports = __webpack_public_path__ + "static/media/photo_tkpa9_2.af539efd.gif";